import {
  MutationActions,
  QueryKeys,
  useEntityMutation,
  queryClient,
} from "@/api/core";
import { useAuth } from "@/contexts/auth/useAuth";
import { useApi } from "@/hooks";
import {
  type Group,
  groupRelationshipSchema,
  type GroupRelationship,
} from "@/schemas";
import { removePageItem } from "@/utils/queries";

interface Variables {
  group: Group;
  id: string;
}

function useCancelMembershipRequest() {
  const api = useApi();
  const { currentAccount } = useAuth();

  return useEntityMutation({
    globalQueryKey: QueryKeys.groupRelationships.global,
    action: MutationActions.UPDATE,
    schema: groupRelationshipSchema,
    mutationFn: (variables: Variables) =>
      api.post(
        `/api/v1/groups/${variables.group.id}/membership_requests/${currentAccount!.id}/reject`,
      ),
    setNextEntity(variables) {
      return {
        ...variables.group.relationship,
        requested: false,
      } as GroupRelationship;
    },
    onSuccess(_data, variables) {
      removePageItem(
        QueryKeys.groups.pending(),
        variables.id,
        (o: any, n: any) => o.id === n,
      );

      // Invalidate so all cancel membership buttons reflect the proper state
      queryClient.invalidateQueries({
        queryKey: QueryKeys.groupRelationships.byGroup(variables.id),
      });
    },
  });
}

export { useCancelMembershipRequest };
